import { create } from './deferred';
import type { Account } from '@patsnap-utils/biz';
import type Passport from '@patsnap-utils/passport/src/passport';
import _ from 'lodash'
/**
 * @description: 获取用户信息
 */
export const accountDeferred = create<Account>()
/**
 * @description: 判断用户是否登录
 */
export const prepareTokenDeferred = create<Passport>()

export const isUserLogin = () => {
    return prepareTokenDeferred.promise.then((token) => !!token).catch(() => false)
}

export function setPrepareTokenDeferred(passport: Passport) {
    prepareTokenDeferred.resolve(passport)
}
